import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=template&id=e906b00a&scoped=true"
import script from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=style&index=0&id=e906b00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e906b00a",
  null
  
)

export default component.exports